// `?compare=<a>,<b>` on the versions page (spec 6.3.8): the two versions to diff.

/** Distinct positive version numbers from the parameter, at most the last two; anything else is ignored. */
export function parseCompare(value: string | null | undefined): number[] {
  const versions: number[] = [];
  for (const raw of (value ?? '').split(',')) {
    const part = raw.trim();
    const version = /^\d{1,9}$/.test(part) ? Number(part) : 0;
    if (version > 0 && !versions.includes(version)) versions.push(version);
  }
  return versions.slice(-2);
}

/** The versions page of a blueprint with two versions selected. */
export function compareHref(blueprintId: string, from: number, to: number): string {
  return `/blueprints/${blueprintId}/versions?compare=${from},${to}`;
}
